<template>
  <div class="shenyunjie-chart-moving-point" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
import merge from "deepmerge";

export default {
  name: "YunJieChartMovingPoint",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: function () {
        return [];
      }
    },
    range: {
      type: Number,
      default: 0.5
    },
    unit: {
      type: String,
      default: ""
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        title: {
          left: "center"
        },
        grid3D: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          viewControl: {
            alpha: 6,
            panMouseButton: "right"
          }
        },
        tooltip: {
          show: false
        },
        xAxis3D: {
          type: "value"
        },
        yAxis3D: {
          type: "value"
        },
        zAxis3D: {
          type: "value"
        }
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeMovingPoint);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeMovingPoint() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        let theme = self.theme || (this.$YunJie || {}).theme || "standard";
        if (!self.chart) {
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        // 配置汇总
        let parameter = {
          title: {
            text: self.title
          },
          grid3D: {
            axisLabel: {
              textStyle: {
                color: theme == "darkness" ? "#cccccc" : "#333333"
              }
            },
            axisLine: {
              lineStyle: {
                color: theme == "darkness" ? "#cccccc" : "#333333"
              }
            }
          },
          xAxis3D: {
            name: `X${self.unit ? ("(" + self.unit + ")") : ""}`,
            min: -self.range,
            max: self.range
          },
          yAxis3D: {
            name: `Y${self.unit ? ("(" + self.unit + ")") : ""}`,
            min: -self.range,
            max: self.range
          },
          zAxis3D: {
            name: `Z${self.unit ? ("(" + self.unit + ")") : ""}`,
            min: -self.range,
            max: self.range
          },
          series: [{
            type: "scatter3D",
            data: [self.value]
          }]
        };
        let opt = merge(self.defaultOption, parameter);
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    },
    update() {
      let self = this;
      if (self.chart) {
        self.chart.setOption({
          series: [{
            data: [self.value]
          }]
        });
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeMovingPoint);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value: {
      deep: true,
      handler(xData) {
        this.update();
      }
    },
    range() {
      this.init();
    },
    unit() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-moving-point {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/movingPoint.vue